import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import ChangePassword from '../components/navbars/ChangePassword';
import BrandLogo from "../components/navbars/BrandLogo";
import CommonHeader from '../components/navbars/CommonHeader';

class PracticeSubmitback extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false
        }
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentemail");
            Cookies.remove("registermob");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("role");
            if (Cookies.get("institution_id") == 119) {
                window.location.href = "https://vignan.rizee.in/login";
            } else {
                this.props.history.push("/student/login");
            }
        }
    };

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        return (
            <div className="PracticeInstructions">
                <CommonHeader color="auto" tone="light" left={<BrandLogo width="159.501" fill="#ffffff" />} />
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-center align-items-center">


                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">You have completed successfully</h6>
                        </div>
                    </Container>

                </div>

                <div className="text-center content-box mt-5 d-flex align-items-center justify-content-center" style={{ height: '66vh' }}>
                    <Container fluid>
                        <Row>
                            <Col xl={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <Image src={require('../../images/success_confirmation.svg')} alt="success-img" width="420" />
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className="bg-white py-3 border-top shadow-sm">
                    <Container>
                        <Row>
                            <Col xl={12} lg={12} md={12} className="text-right">

                                <Link onClick={this.props.pcancelFunction} className="btn btn-outline-primary px-5"><i className="fal fa-arrow-left" />
                                    Close</Link>


                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}

export default PracticeSubmitback
